module.exports = __webpack_public_path__ + "img/default-product.38a476ae.jpg";